module.exports = __webpack_public_path__ + "static/img/iamge00yu@2x.c4d774f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iamge00yu@2x.jpg
// module id = 420
// module chunks = 1